import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const showApi = {
  list (params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/shows/`,
      {params: params})
  },
  detail (showSlug, params) {
    // let params = querystring..stringify(params)
    return axios.get(`${ApiSetting.baseUrl}/api/shows/${showSlug}/`, {params: params})
  },
  getId (showSlug, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/shows/${showSlug}/getid/`, {params: params})
  },
  getPrices (showSlug, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/shows/${showSlug}/getprices/`, {params: params})
  },
  syncFeed (showSlug, params) {
    return axios.post(
      `${ApiSetting.baseUrl}/api/shows/${showSlug}/parse_from_feed/`, querystring.stringify(params))
  }
}

export default showApi
